module.exports = __webpack_public_path__ + "img/13.634ebd3f.jpg";